import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import JumboDemoCard from "@jumbo/components/JumboDemoCard/JumboDemoCard";
import { inactiveusers } from "backendServices/ApiCalls";

function InactiveUsers() {
  const [userList, setUserList] = useState([]);

  const fetchInactiveUsers = () => {
    inactiveusers(
      (response) => {
        const processedData = response?.data?.data.map((row, index) => ({
          ...row,
          id: index + 1,
        }));
        setUserList(processedData || []);
      },
      (error) => {}
    );
  };

  useEffect(() => {
    fetchInactiveUsers();
  }, []);

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const columns = [
    { field: "id", headerName: "#", width: 60 },
    { field: "username", headerName: "User Name", width: 200 },
    { field: "firstname", headerName: "First Name", width: 150 },
    { field: "lastname", headerName: "Last Name", width: 150 },
    { field: "email", headerName: "Email", width: 220 },
    {
      field: "lastlogin",
      headerName: "Last Login",
      width: 200,
      valueFormatter: (params) => formatDate(params.value),
    },
    { field: "login_status", headerName: "Login Status", width: 140 },
    { field: "trial", headerName: "On Trial", width: 110 },
    { field: "subscription_status", headerName: "Subscription", width: 160 },
  ];

  return (
    <Box p={2}>
      <JumboDemoCard
        title="Inactive Users"
        wrapperSx={{ backgroundColor: "background.paper", pt: 0 }}
      >
        <Box sx={{ height: 500, width: 1 }}>
          <DataGrid
            initialState={{
              pagination: { paginationModel: { pageSize: 12 } },
            }}
            rows={userList}
            getRowId={(row) => row.id}
            columns={columns}
            slots={{ toolbar: GridToolbar }}
            pageSizeOptions={[12, 24, 50]}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
          />
        </Box>
      </JumboDemoCard>
    </Box>
  );
}

export default InactiveUsers;
